import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeAdminComponent } from './home-admin.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: HomeAdminComponent,
        data: {
          title: "Uy",
          breadcrumb: "Uy"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeAdminRoutingModule { }
